import Swiper from 'swiper';

export default function() {
  const insightsSlider = document.querySelectorAll('.insights');

  insightsSlider.forEach((block) => {
    const slider = block.querySelector('.swiper-container');

    const swiper = new Swiper(slider, {
      direction: 'horizontal',
      slidesPerView: '1',
      speed: 1000,
      pagination: {
        el: block.querySelector('.swiper-pagination'),
        type: 'bullets',
        clickable: 'true',
      },
      navigation: {
        nextEl: block.querySelector('.swiper-button-next'),
        prevEl: block.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        767: {
          slidesPerView: '2',
          pagination: false,
          navigation: false,
          allowTouchMove: false,
        },
      },
    });
  });
}
